import PropTypes from "prop-types";
import React from "react";

const BookPurple = (props) => (
  <svg
    height={20}
    viewBox="0 0 24 20"
    width={24}
    fill="currentColor"
    {...props}
    style={{
      verticalAlign: "middle",
      color: props.color,
      ...props.style,
    }}
  >
    <g
      id="Journey-4---Inbox"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="1.9--all-notifications"
        transform="translate(-181.000000, -247.000000)"
        fill="#7450C8"
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(181.000000, 240.000000)">
          <g id="Group-2">
            <g id="book-open" transform="translate(0.000000, 7.000000)">
              <path
                d="M22.4126004,0.709973034 C21.5960441,0.569324487 20.7691924,0.496927332 19.9406186,0.493532238 C17.1136344,0.491214631 14.3456074,1.30185112 11.966484,2.82881452 C9.58124715,1.32189998 6.81365633,0.531159748 3.99234942,0.550490342 C3.16377562,0.553885436 2.3369239,0.626282591 1.52036769,0.766931139 C0.967787683,0.862196281 0.566711398,1.34542072 0.574863155,1.90609323 L0.574863155,15.5760383 C0.569923705,15.9149181 0.716132458,16.2384005 0.973767178,16.4586011 C1.2314019,16.6788017 1.57370639,16.7728521 1.9076828,16.7152004 C5.20558975,16.1441951 8.59435122,16.9287448 11.30577,18.8909999 L11.4424695,18.9707413 L11.5677773,18.9707413 C11.8229496,19.0770631 12.1100184,19.0770631 12.3651908,18.9707413 L12.4904986,18.9707413 L12.627198,18.8909999 C15.319877,16.8847491 18.7103146,16.0546056 22.0252853,16.5898925 C22.3592617,16.6475442 22.7015662,16.5534939 22.9592009,16.3332933 C23.2168356,16.1130927 23.3630443,15.7896103 23.3581049,15.4507304 L23.3581049,1.7807854 C23.3336822,1.24602916 22.9402179,0.800418945 22.4126004,0.709973034 Z M10.8273219,15.8494372 C8.71973931,14.7406771 6.37378832,14.1620092 3.99234942,14.1634773 C3.61642593,14.1634773 3.24050244,14.1634773 2.85318733,14.1634773 L2.85318733,2.77185641 C3.23259323,2.74999016 3.61294351,2.74999016 3.99234942,2.77185641 C6.42262163,2.76917058 8.79985752,3.48234135 10.8273219,4.82234817 L10.8273219,15.8494372 Z M21.0797807,14.2090438 C20.6924656,14.2090438 20.3165421,14.2090438 19.9406186,14.2090438 C17.5591797,14.2075757 15.2132287,14.7862436 13.1056461,15.8950037 L13.1056461,4.82234817 C15.1331105,3.48234135 17.5103464,2.76917058 19.9406186,2.77185641 C20.3200245,2.74999016 20.7003748,2.74999016 21.0797807,2.77185641 L21.0797807,14.2090438 Z M22.4126004,18.9365664 C21.5960441,18.7959179 20.7691924,18.7235207 19.9406186,18.7201256 C17.1136344,18.717808 14.3456074,19.5284445 11.966484,21.0554079 C9.58736067,19.5284445 6.81933363,18.717808 3.99234942,18.7201256 C3.16377562,18.7235207 2.3369239,18.7959179 1.52036769,18.9365664 C1.22086573,18.9840953 0.952675591,19.1490799 0.775203799,19.3949745 C0.597732008,19.6408692 0.525627889,19.9473767 0.574863155,20.2466028 C0.695391612,20.8625056 1.2913619,21.2649129 1.9076828,21.1465409 C5.20558975,20.5755357 8.59435122,21.3600853 11.30577,23.3223405 C11.7012464,23.6039163 12.2317216,23.6039163 12.627198,23.3223405 C15.3386168,21.3600853 18.7273783,20.5755357 22.0252853,21.1465409 C22.6416061,21.2649129 23.2375764,20.8625056 23.3581049,20.2466028 C23.4073402,19.9473767 23.335236,19.6408692 23.1577643,19.3949745 C22.9802925,19.1490799 22.7121023,18.9840953 22.4126004,18.9365664 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

BookPurple.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
};

export default BookPurple;
